import { Outlet } from 'react-router-dom';

export default function Data() {
  return <Outlet />;
}

